// extracted by mini-css-extract-plugin
export default {"wrapper":"tz-z","viewport":"uz-z","container":"vz-z","slide":"wz-z"};